import React from 'react';
import PropTypes from 'prop-types';

export default class Event extends React.Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    actor: PropTypes.node.isRequired,
    message: PropTypes.string.isRequired,
    timestamp: PropTypes.node.isRequired,
    onClick: PropTypes.func.isRequired,
    className: PropTypes.string,
  };

  static defaultProps = {
    className: '',
  };

  handleClick = () => {
    const { id, onClick } = this.props;

    onClick(id);
  };

  render() {
    const {
      actor,
      message,
      timestamp,
      className,
    } = this.props;

    return (
      <tr onClick={this.handleClick} className={className}>
        <td>{actor}</td>
        <td>{timestamp}</td>
        <td>{message}</td>
      </tr>
    );
  }
}
